import { BsBox2 } from 'react-icons/bs';

import ContractSection from './ContractSection';
import { getAmountWithThousandSeparators, getPriceRange } from './helper';

const SERVICE_TYPE = {
  W: 'execution',
  O: 'executionOnDemand',
};

const TITLE = {
  W: 'Агуулах дээрх захиалга гүйцэтгэл',
  O: 'Татан авалттай захиалга гүйцэтгэл',
};

const DESCRIPTION = {
  W: 'Агуулахад байршуулсан бараанаас захиалга бэлтгэх шимтгэл. Захиалгын дүнгийн шатлалаар бодогдоно.',
  O: 'Салбараас татан авч захиалга бэлтгэх шимтгэл. Захиалгын дүнгийн шатлалаар бодогдоно.',
};

/** Дүн эсвэл хувь — гэрээнд аль нь тохирсноос хамаарна */
const amountOrPercent = (enabled, isAmount, amount, percent) => {
  if (!enabled) return '-';

  return `${getAmountWithThousandSeparators(isAmount ? amount : percent)}${isAmount ? '₮' : '%'}`;
};

const columns = [
  {
    key: 'orderAmount',
    title: 'Захиалгын дүн',
    render: (_, service) => getPriceRange(service.lowPrice, service.highPrice),
  },
  {
    key: 'b2b',
    title: 'B2B',
    align: 'right',
    render: (_, service) =>
      amountOrPercent(service?.isB2B, service.isB2Bamount, service.B2Bamount, service.B2Bpercent),
  },
  {
    key: 'b2c',
    title: 'B2C',
    align: 'right',
    render: (_, service) =>
      amountOrPercent(service?.isB2C, service.isB2Camount, service.B2Camount, service.B2Cpercent),
  },
];

const Execution = ({ services = [], type }) => {
  const executionServices = services.filter(
    (service) => service.serviceType === SERVICE_TYPE[type]
  );

  if (!executionServices.length) return null;

  return (
    <ContractSection
      icon={BsBox2}
      title={TITLE[type]}
      description={DESCRIPTION[type]}
      columns={columns}
      dataSource={executionServices}
    />
  );
};

export default Execution;
